<template>
  <header id="top">
    <div class="app-header">
      <div class="clearfix header-wrapper">
        <div class="logo-wrapper">
          <router-link to="/">
            <div class="imageLogo">
              <img :src="portalInfo.logoUrl" alt>
              <!-- <div class="portalName">
                <span class="name" :title="portalInfo.name"> {{ portalInfo.name }}</span>
              </div> -->
            </div>
          </router-link>
        </div>
        <div class="nav-box">
          <div class="nav-wrapper">
            <ul id="header-nav" class="headerbntNav">
              <li
                v-for="item in hearderNavList"
                :key="item.id"
                :class="activeNum === item.name ? 'active' : ''"
                @mouseover="navMouseoveText = item.id"
                @mouseout="navMouseoveText = ''"
              >
                <span v-if="item.url && item.url.indexOf('{website}') === 0">
                  <router-link
                    :to="{ path: $util.getParenthesesStr(item.url) }"
                    :target="item.openType === 1 ? '_self' : '_blank'"
                    :title="item.name"
                  >
                    {{ item.name
                    }}<i v-if="item.subList.length > 0" class="el-icon-arrow-down" /></router-link>
                </span>
                <span v-else-if="item.url && item.url !== 'javascript:;'">
                  <a
                    :href="item.url | urlAddToken"
                    :target="item.openType === 1 ? '_self' : '_blank'"
                    :title="item.name"
                  >{{ item.name
                  }}<i v-if="item.subList.length > 0" class="el-icon-arrow-down" /></a>
                </span>
                <span v-else>
                  <a href="javascript:void(0);" :title="item.name">{{ item.name
                  }}<i v-if="item.subList.length > 0" class="el-icon-arrow-down" /></a>
                </span>
                <ul
                  v-if="item.subList.length > 0"
                  class="headerbntNav-sub"
                  :class="navMouseoveText === item.id ? 'navMouseoveText ' : ''"
                >
                  <li v-for="subitem in item.subList" :key="subitem.id">
                    <span
                      v-if="
                        subitem.url && subitem.url.indexOf('{website}') === 0
                      "
                    >
                      <router-link
                        :to="{ path: $util.getParenthesesStr(subitem.url) }"
                        :target="subitem.openType === 1 ? '_self' : '_blank'"
                        :title="subitem.name"
                      >
                        {{ subitem.name }}</router-link>
                    </span>
                    <span v-else-if="subitem.url && subitem.url !== 'javascript:;'">
                      <a
                        :href="subitem.url | urlAddToken"
                        :target="subitem.openType === 1 ? '_self' : '_blank'"
                        :title="subitem.name"
                      >{{ subitem.name }}</a>
                    </span>
                    <span v-else>
                      <a href="javascript:void(0);" :title="subitem.name">{{
                        subitem.name
                      }}</a>
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="personal-wrapper">
            <div v-if="userInfo.accountId" style="display: inline-block; line-height: 64px">
              <!-- <el-select v-if="userInfo && userInfo.org && userInfo.org.length > 0" v-model="currtentOrg" class="org">
              <el-option v-for="(item,index) in userInfo.org" :key="item.orgCode+index" :label="item.orgName" :value="item.orgCode" />
            </el-select> -->
              <!-- <span class="msg">
              <div v-show=" oaMessage.systemMessage > 0" class="num" />
              <a :href="oaMessage.oaUrl|urlAddToken" :target="oaMessage.oaUrl ? '_blank':'_self'">
                <img src="@/assets/img/msg.png" class="msgImg" alt>
              </a>
            </span> -->
              <span class="msg">
                <div v-show="oaMessage.systemMessage > 0" class="num" />
                <a :href="oaMessage.oaUrl | urlAddToken" :target="oaMessage.oaUrl ? '_blank' : '_self'">
                  <img
                    :src="userInfo.profilePhotoPath
                      ? userInfo.profilePhotoPath
                      : require('@/assets/img/avater.png')
                    "
                    alt
                    class="profilePhotoPath"
                  >
                </a>
              </span>
              <span :title="userInfo.name" class="uername">{{
                userInfo.name
              }}</span>
              <el-dropdown class="org-container" placement="bottom" @command="handleCommand">
                <i class="el-icon-arrow-down" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-user" command="c">
                    个人中心
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-unlock" command="b">
                    修改密码
                  </el-dropdown-item>
                  <el-dropdown-item v-if="linkUrl" icon="el-icon-setting" command="d">
                    {{ openSso ? '业务中台' : '后台管理' }}
                  </el-dropdown-item>
                  <el-dropdown-item divided icon="el-icon-switch-button" command="a">
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-else style="display: inline-block">
              <el-button type="primary blueBntLogin" size="medium" @click="handleCloseLogin(true)">
                登录
              </el-button>
            </div>
          </div>
          <div style="position: absolute; right: 130px">
            <div v-show="sarchShow" id="home-search" class="home-search" style="opacity: 0">
              <i class="el-icon-close icon" @click="fadeInOut('close')" />
              <div class="search-div">
                <el-input
                  v-model="searchForm.text"
                  placeholder="请输入您要查询的内容"
                  class="input-with-select"
                  @keyup.enter.native="searchCon"
                >
                  <el-select slot="prepend" v-model="searchForm.searchClass" @change="changeItem">
                    <el-option label="全部" value="all" />
                    <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                  <el-button slot="append" icon="el-icon-search" @click="searchCon" />
                </el-input>
              </div>
            </div>
            <i class="el-icon-search sarchIcon" :style="{ opacity: !sarchShow ? 1 : 0 }" @click="fadeInOut('show')" />
          </div>
        </div>
      </div>
    </div>
    <div class="header-nav-h5">
      <div class="logo-wrapper">
        <router-link to="/">
          <div class="imageLogo">
            <img :src="portalInfo.logoUrl" alt>
          </div>
        </router-link>
      </div>
      <div style="margin-right: 10px">
        <img
          v-if="userInfo.accountId"
          :src="userInfo.profilePhotoPath
            ? userInfo.profilePhotoPath
            : require('@/assets/img/avater.png')
          "
          alt="center"
          style="margin-right: 16px"
          class="profilePhotoPathH5"
          @click.stop="toggleCenter"
        >
        <img
          v-else
          src="@/assets/img/perIcon.png"
          alt="perIcon"
          style="margin-right: 16px;vertical-align: middle;"
          @click="toggleLogin(true)"
        >
        <img src="@/assets/img/moreIcon.png" alt="moreIcon" style="vertical-align: middle;" @click.stop="toggleNavbar">
      </div>
      <div v-if="isCenterOpen" class="h5list centerh5list">
        <div class="contentWarp" />
        <div class="content">
          <ul>
            <li>
              <i class="el-icon-user" />
              <div class="item" @click="handleCommand('c')">
                个人中心
              </div>
            </li>
            <li>
              <i class="el-icon-unlock" />
              <div class="item" @click="handleCommand('b')">
                修改密码
              </div>
            </li>
            <li>
              <i class="el-icon-setting" />
              <div class="item" @click="handleCommand('d')">
                {{ openSso ? '业务中台' : '后台管理' }}
              </div>
            </li>
            <li>
              <i class="el-icon-switch-button" />
              <div class="item" @click="handleCommand('a')">
                退出登录
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="isNavbarOpen" class="h5list">
        <div class="contentWarp" />
        <div class="content">
          <ul>
            <li
              v-for="item in hearderNavList"
              :key="item.id"
              :class="activeNum === item.name
                ? 'h5active'
                : ''
              "
            >
              <div class="item">
                <span v-if="item.url && item.url.indexOf('{website}') === 0">
                  <router-link
                    :to="{ path: $util.getParenthesesStr(item.url) }"
                    :target="item.openType === 1 ? '_self' : '_blank'"
                    :title="item.name"
                  >
                    {{ item.name
                    }}<i v-if="item.subList.length > 0" class="el-icon-arrow-down" /></router-link>
                </span>
                <span v-else-if="item.url && item.url !== 'javascript:;'">
                  <a
                    :href="item.url | urlAddToken"
                    :target="item.openType === 1 ? '_self' : '_blank'"
                    :title="item.name"
                  >{{ item.name
                  }}<i v-if="item.subList.length > 0" class="el-icon-arrow-down" /></a>
                </span>
                <span v-else>
                  <a href="javascript:void(0);" :title="item.name">{{ item.name
                  }}<i v-if="item.subList.length > 0" class="el-icon-arrow-down" /></a>
                </span>
                <i
                  v-if="activeNum === item.name && item.subList.length > 0"
                  class="el-icon-arrow-up arrow"
                  @click="activeNum = ''"
                /><i
                  v-else-if="item.children"
                  class="el-icon-arrow-down arrow"
                  @click="activeNum = item.name"
                />
              </div>
              <ul v-if="item.subList.length > 0" class="subNav">
                <li v-for="subitem in item.subList" :key="subitem.id">
                  <span
                    v-if="
                      subitem.url && subitem.url.indexOf('{website}') === 0
                    "
                  >
                    <router-link
                      :to="{ path: $util.getParenthesesStr(subitem.url) }"
                      :target="subitem.openType === 1 ? '_self' : '_blank'"
                      :title="subitem.name"
                    >
                      {{ subitem.name }}</router-link>
                  </span>
                  <span v-else-if="subitem.url && subitem.url !== 'javascript:;'">
                    <a
                      :href="subitem.url | urlAddToken"
                      :target="subitem.openType === 1 ? '_self' : '_blank'"
                      :title="subitem.name"
                    >{{ subitem.name }}</a>
                  </span>
                  <span v-else>
                    <a href="javascript:void(0);" :title="subitem.name">{{
                      subitem.name
                    }}</a>
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <Login v-show="hiddenVariable.dialogEditVisible" @visible="handleCloseLogin" />
    <!-- <el-dialog
      :close-on-click-modal="false"
      destroy-on-close
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="logainTitle"
      width="380px"
    >
      <Login @visible="handleCloseLogin" />
    </el-dialog> -->
    <el-dialog
      v-if="dialogEditPwdVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogEditPwdVisible"
      title="修改密码"
      width="400px"
      class="editpwd"
    >
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-position="right" label-width="100px">
        <el-form-item prop="oldPassword" label="当前密码：">
          <el-input
            v-model.trim="editForm.oldPassword"
            :maxlength="16"
            name="oldPassword"
            type="password"
            auto-complete="off"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码：">
          <el-input
            v-model.trim="editForm.newPassword"
            :maxlength="16"
            name="newPassword"
            type="password"
            auto-complete="off"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <div class="tip">
          忘记密码，请联系管理员重置
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogEditPwdVisible = false">
          取消
        </el-button>
        <span class="line" style="display: none;" />
        <el-button type="primary red" size="medium" @click="handleEditPwd">
          确定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogViewUserVisible"
      title="个人信息"
      width="650px"
    >
      <div class="user-dialog-main">
        <div class="user-dialog-left">
          <img
            :src="userInfo.profilePhotoPath
              ? userInfo.profilePhotoPath
              : require('@/assets/img/avater.png')
            "
            alt
          >
        </div>
        <div class="user-dialog-right">
          <ul>
            <li>
              <label for>账号：</label>
              <span>{{ userInfo.account }}</span>
              <span
                :data-clipboard-text="userInfo.account"
                class="clipboardName"
                @click="copy('.clipboardName')"
              >复制账号</span>
            </li>
            <li>
              <label for>手机号：</label>
              <span>{{ userInfo.phone }}</span>
              <span
                :data-clipboard-text="userInfo.phone"
                class="clipboardPhone"
                @click="copy('.clipboardPhone')"
              >复制手机号</span>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </header>
</template>

<script>
import { editPassword } from '@/api/user';
import MD5 from 'md5';
import { getToken } from '@/utils/storage';
import ClipboardJS from 'clipboard';
import { mapGetters } from 'vuex';
import Login from '@/views/login/login';
// import LoginH5 from '@/views/login/loginH5';
// 获取API
import getContent from '@/api/content';
// import ENVIRONMENT from '@/utils/environment';
export default {
  name: 'AppHeader',
  components: {
    Login
  },
  props: {
    topScroll: {
      default: false,
      type: Boolean
    }
  },
  data() {
    const validateOldPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('原密码不能为空'));
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('原密码长度在6-16位'));
      } else {
        callback();
      }
    };
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('新密码不能为空'));
      } else if (value === this.editForm.oldPassword) {
        callback(new Error('新密码不能和旧密码一致'));
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('新密码长度在6-16位'));
      } else {
        callback();
      }
    };
    return {
      isCenterOpen: false,
      isNavbarOpen: false,
      currtentOrg: '',
      logainTitle: '快捷登录',
      hiddenVariable: {
        dialogEditVisible: false
      },
      dialogEditPwdVisible: false,
      dialogViewUserVisible: false, // 查看用户信息
      editForm: {
        oldPassword: '',
        newPassword: ''
      },
      searchForm: {
        searchClass: 'all',
        text: '',
        code: 'all',
        tabIndex: ''
      },
      sarchShow: false,
      typeList: [],
      navMouseoveText: '',
      editFormRules: {
        oldPassword: [
          { required: true, trigger: 'blur', validator: validateOldPassword }
        ],
        newPassword: [
          { required: true, trigger: 'blur', validator: validateNewPassword }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'portalInfo', 'hearderNavList', 'oaMessage']),
    // headerRouter() {
    //   return [
    //     { path: '/', name: 'layout', meta: { title: '首页' }}
    //   ];
    // },
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
    navList() {
      return this.hearderNavList;
    },
    activeNum() {
      let active = '';
      if (this.hearderNavList.find(v => v.name === this.$route.meta.title)) {
        active = this.hearderNavList.find(
          v => v.name === this.$route.meta.title
        ).name;
      }
      return active;
    },
    roleName() {
      return (
        this.userInfo.roleVOList &&
        this.userInfo.roleVOList.map(x => x.name).join('，')
      );
    },
    linkUrl() {
      return (
        this.$store.state.user.manageSsoUrl &&
        this.$store.state.user.manageSsoUrl.url
      );
    },
    openSso() {
      return (
        this.$store.state.user.manageSsoUrl &&
        this.$store.state.user.manageSsoUrl.opensso
      );
    }
  },
  watch: {
    $route() {
      this.fadeInOut('close');
    }
  },
  mounted() {
    setTimeout(() => {
      console.log(this.oaMessage, 'oaMessageoaMessage');
    }, 3000);
    this.getSearchTypeAll();
    getToken() && this.$store.dispatch('FetchManageUrl');
    if (this.userInfo.org && this.userInfo.org.length > 0) {
      this.currtentOrg = this.userInfo.org[0].orgCode;
    }
    const _this = this;
    document.addEventListener(
      'click',
      function() {
        _this.isNavbarOpen = false;
        _this.isCenterOpen = false;
      },
      false
    );
  },
  methods: {
    toggleNavbar() {
      setTimeout(() => {
        this.isNavbarOpen = !this.isNavbarOpen;
        this.isCenterOpen = false;
      }, 10);
    },
    toggleCenter() {
      setTimeout(() => {
        this.isNavbarOpen = false;
        this.isCenterOpen = !this.isCenterOpen;
      }, 10);
    },
    toggleLogin(val) {
      this.hiddenVariable.dialogEditVisible = val;
    },
    fadeInOut(val) {
      this.searchForm = {
        searchClass: 'all',
        text: '',
        code: 'all',
        tabIndex: ''
      };
      const search = document.getElementById('home-search');
      const nav = document.getElementById('header-nav');
      if (val === 'show') {
        this.sarchShow = true;
        this.topScroll && this.$util.fadeOut(nav, 30);
        this.$util.fadeIn(search, 30);
      } else {
        this.sarchShow = false;
        this.topScroll && this.$util.fadeIn(nav, 30);
        this.$util.fadeOut(search, 30);
      }
    },
    // 获取搜索全部分类
    getSearchTypeAll() {
      getContent['getSearchitem']().then(res => {
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.typeList = [];
        } else {
          this.typeList = res.data;
        }
      });
    },
    // 搜索内容
    searchCon() {
      if (this.searchForm.text) {
        localStorage.setItem('index', this.searchForm.tabIndex);
        this.$router.push({
          path:
            '/search/' +
            this.searchForm.code +
            '/' +
            this.searchForm.searchClass,
          query: { wd: this.searchForm.text }
        });
      }
    },
    // 搜索分类切换
    changeItem(e) {
      if (e === 'all') {
        this.searchForm.tabIndex = 0;
        this.searchForm.code = e;
        return;
      }
      this.typeList.map((item, index) => {
        if (item.id === e) {
          this.searchForm.tabIndex = index + 1;
          this.searchForm.code = item.code;
          localStorage.setItem('iframeUrl', item.outsideUrl);
        }
      });
    },
    // 复制功能
    copy(el) {
      var clipboard = new ClipboardJS(el);
      clipboard.on('success', () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        });
        clipboard.on('destory');
      });
      clipboard.on('error', () => {
        clipboard.on('destory');
      });
    },

    handleCommand(command) {
      if (command === 'a') {
        // 退出
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push('/');
          location.reload();
        });
      } else if (command === 'b') {
        // 修改密码
        this.editForm = {
          oldPassword: '',
          newPassword: ''
        };
        this.dialogEditPwdVisible = true;
      } else if (command === 'd') {
        // 获取后台管理地址
        const url = `${this.linkUrl}${getToken()}`;
        window.open(url);
      } else {
        // 用户信息
        this.dialogViewUserVisible = true;
      }
    },
    // 修改密码
    handleEditPwd() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          const submitForm = {
            accountId: this.userInfo.accountId,
            oldPassword: MD5(this.editForm.oldPassword).toUpperCase(),
            password: MD5(this.editForm.newPassword).toUpperCase()
          };
          editPassword(submitForm)
            .then(() => {
              this.$notify.success({
                title: 'Success',
                message: '修改成功',
                showClose: false,
                duration: 2000
              });
              this.dialogEditPwdVisible = false;
            })
            .catch(() => { });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 登录弹窗关闭
    handleCloseLogin(val) {
      this.hiddenVariable.dialogEditVisible = val;
      this.$store.commit('SET_LOGINSHOW', val); // 登录页显示，底层的内容去掉滚动状态
    },
    // 个人信息弹窗关闭
    handleClose() {
      this.dialogViewUserVisible = false;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.el-select-dropdown__item.selected {
  color: #334eb4 !important;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #334eb4 !important;
  color: #fff !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #334eb4 !important;
  color: #fff !important;
}
.el-select-dropdown {
  border-radius: 8px !important;
}
.search-div {
  background: #334eb4;
  border-radius: 60px;
  margin-right: 30px;
  .el-select {
    position: relative;
  }
  .el-select::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -5px;
    width: 1px;
    height: 16px;
    background: #bbc0cb;
    opacity: 0.5;
    margin-top: -8px;
  }
  .el-select .el-input {
    width: 130px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: transparent;
    border: 1px solid transparent;
    border-right: 0;
  }
  .el-input-group__append {
    background-color: transparent;
    border: 1px solid transparent;
    color: #fff !important;
    font-size: 20px;
    padding: 0 20px;
  }

  .el-input--medium .el-input__inner {
    height: 46px;
    line-height: 46px;
    padding: 0 20px;
    background-color: transparent;
    border: 1px solid transparent;
    border-left: 0;
    color: #fff !important;
  }
}
@media screen and (max-width: 768px) {
  // 修改dialog全局样式
  .el-dialog {
    margin-top: 10vh !important;
    margin-bottom: 10vh;
    border-radius: 8px!important;
    width: 90%!important;
    background: #fff;
    .el-dialog__header {
      background: #fff !important;
      padding: 20px 13px 0 !important;
      border-top-left-radius: 8px !important;
      border-top-right-radius: 8px !important;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      text-align: center;
      .el-dialog__title {
        font-size: 18px !important;
        border-left: 0;
        padding-left: 10px;
        color: #666 !important;
      }
      .el-dialog__headerbtn {
        background: #fff;
        border-radius: 50%;
        padding-top: 3px;
        padding-bottom: 1px;
        padding-left: 2px;
        padding-right: 1px;
        width: 22px;
        height: 22px;
        top: 14px;
        &:hover {
          background: #EEF7FF;
        }
        .el-dialog__close {
          color: #666 !important;
          font-size: 24px;
        }
      }
    }
    .el-dialog__body {
      background: #fff !important;
      padding-right: 20px !important;
      padding-bottom: 5px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 8px !important;
      border-bottom-left-radius: 8px!important;
    }
    .el-dialog__footer {
      background: #fff !important;
      padding-right: 20px !important;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 8px!important;
      border-bottom-left-radius: 8px!important;
      .dialog-footer {
        display: flex;
        justify-content: space-around;
        .blue {
          color: #fff;
          background-color: #334EB4;
          border: none;
          box-shadow: 0 0 2px rgb(255, 255, 255) inset;
          &:hover {
            background-color: #334EB4;
            border-color: #334EB4;
            box-shadow: 0 0 2px rgb(255, 255, 255) inset;
          }
        }
      }
    }
    .el-input__inner {
      height: 46px;
      line-height: 46px;
      padding: 0 20px;
      background-color: transparent;
      border: none;
      border-bottom: 1px solid #f2f2f2;
      border-left: 0;
      color: #fff !important;
      border-radius: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
  .profilePhotoPathH5 {
    vertical-align: middle;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin-right: 5px;
    background: #007afc;
    border: #007afc solid 2px;
    vertical-align: middle;
  }
.msg {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  .num {
    position: absolute;
    right: 10px;
    top: 18px;
    background: #d52727;
    color: #fff;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    text-align: center;
    line-height: 16px;
  }
}
.app-header {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 160px;
  color: #fff;
  background: #2658b7 url('../../../src/assets/img/bg-top.png');
  // background: rgba(0, 24, 46, 1);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  .header-wrapper {
    margin: 0 auto;
    width: 1200px;
    position: relative;
    height: 160px;
    .logo-wrapper {
      font-size: 18px;
      display: flex;
      align-items: center;
      a {
        display: inline-block;
        .imageLogo {
          height: 50px;
          width: 288px;
          margin-top: 32px;
          img {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
          .portalName {
            max-width: 200px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            vertical-align: middle;
            display: inline-block;
            -webkit-line-clamp: 1;
          }
          .name {
            margin-left: 6px;
            padding-left: 8px;
            border-left: 1px solid #63c2ff;
            font-weight: bold;
          }
        }
      }
    }
    .sarchIcon {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      margin-right: 30px;
      &:hover {
        color: #fff;
      }
    }
    .home-search {
      position: relative;
      line-height: 46px;
      padding-left: 20px;
      .icon {
        font-size: 16px;
        color: #fff;
      }
      .search-div {
        width: 470px;
        display: inline-block;
        margin-left: 15px;
      }
    }
    .headerbntNav {
      li {
        width: 100px;
        text-align: center;
        font-size: 18px;
        display: inline-block;
        vertical-align: top;
        position: relative;
        span {
          position: relative;
        }
        span::after {
          content: '';
          width: 100%;
          height: 4px;
          background: transparent;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          display: inline-block;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        &.active a {
          color: #fff;
        }
        &.active span::after {
          background: #fff;
        }
        .headerbntNav-sub {
          display: none;
          position: absolute;
          top: 68px;
          z-index: 9999;
          background: #fff;
          padding: 10px 0;
          background-color: #fff;
          border: 1px solid #ebeef5;
          border-radius: 4px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
          &::after {
            content: '';
            border-width: 6px;
            position: absolute;
            display: none;
            width: 0;
            top: -6px;
            left: 50%;
            height: 0;
            border-color: transparent;
            border-style: solid;
            z-index: 999;
            bottom: 1px;
            margin-left: -6px;
            border-bottom-color: #fff;
            border-top-width: 0;
          }
          li {
            width: auto;
            min-width: 110px;
            height: auto;
            line-height: normal;
            color: #606266;
            cursor: pointer;
            outline: 0;
            padding: 0;
            margin: 0;
            display: block;
            font-size: 14px;
            position: static;
            vertical-align: inherit;
            &:hover {
              background: #2861d8;
              color: #fff;
              span {
                color: #fff;
              }
            }
            span {
              line-height: 30px;
              &::after {
                display: none;
              }
            }
            a {
              font-weight: normal;
              line-height: inherit;
              display: initial;
              color: inherit;
              &:hover {
                font-weight: normal;
                line-height: inherit;
                display: initial;
                color: inherit;
              }
            }
            &::after {
              display: none;
            }
          }
        }
        .navMouseoveText {
          display: block;
        }
      }
    }
    .nav-box {
      width: 100%;
      line-height: 64px;
      height: 64px;
      position: absolute;
      bottom: 0;
    }
    .nav-wrapper {
      float: left;
      position: relative;
      span {
        max-width: 132px;
        text-align: center;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      // .active,.router-link-exact-active {
      //   color: #fff;
      //   font-size: 16px;
      //   position: relative;
      //   &::before{
      //     content: '';
      //     display: inline-block;
      //     width: 100%;
      //     position: absolute;
      //     left: 0;
      //     bottom: 0;
      //     border: 2px solid #E50013;
      //   }
      // }
    }
    .nav-wrapper .headerbntNav span a:hover {
      color: #fff;
    }
    .nav-wrapper .headerbntNav-sub span a:hover {
      color: #007afc;
    }
    .headerbntNav li span:hover::after {
      background: #fff;
    }
    .nav-wrapper .headerbntNav-sub li span:hover::after {
      display: none;
    }
    .personal-wrapper {
      float: right;
      width: 130px;
      line-height: normal;
      .org {
        width: 148px;
        margin-right: 10px;
      }
      .uername {
        max-width: 56px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: middle;
        display: inline-block;
        -webkit-line-clamp: 1;
      }
      .message {
        margin-right: 30px;
        font-size: 18px;
        position: relative;
        i {
          font-size: 12px;
          font-style: normal;
          width: 16px;
          height: 16px;
          background: red;
          border-radius: 50%;
          display: inline-block;
          text-align: center;
          line-height: 16px;
          position: absolute;
          left: 10px;
          top: -8px;
        }
      }
      img.profilePhotoPath {
        vertical-align: middle;
        height: 45px;
        width: 45px;
        border-radius: 50%;
        margin-right: 5px;
        background: #007afc;
        border: #007afc solid 2px;
        margin-top: -10px;
      }
      .org-container {
        color: #fff;
        cursor: pointer;
        margin-left: 10px;
        .el-icon-more {
          color: #fff;
          margin-left: 10px;
          transform: rotate(90deg);
          cursor: pointer;
        }
      }
    }
  }
}
.user-dialog-main {
  padding: 20px;
  display: flex;
  .user-dialog-left {
    width: 250px;
    text-align: center;
    img {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      margin-bottom: 10px;
    }
  }
  .user-dialog-right {
    margin-top: 30px;
    ul {
      li {
        margin-bottom: 30px;
        font-size: 14px;
        .clipboardName,
        .clipboardPhone {
          color: #007afc;
          margin-left: 10px;
          cursor: pointer;
          font-size: 14px;
          border: 1px solid #007afc;
          padding: 2px 4px;
          vertical-align: middle;
          &:hover {
            // text-decoration: underline;
          }
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
}
.centerh5list {
  li {
    display: flex;
    margin-left: 20px;
    align-items: center;
    border-top: 1px solid rgba($color: #ffffff, $alpha: .2);
    .item {
      border: none !important;
    }
  }
}
.h5list {
  position: absolute;
  z-index: 89;
  top: 66px;
  width: 100%;
  color: #fff;
  font-size: 18px;
  .contentWarp {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 333;
  }
  .content {
    width: 100%;
    position: absolute;
    z-index: 444;
    background: #2858E0;
  }
  li {
    line-height: 60px;
    .item {
      border-top: 1px solid rgba($color: #ffffff, $alpha: .2);
      a{
        padding-left: 26px;
        line-height: 60px;
        display: block;
      }
    }
    .arrow {
      padding-right: 26px;
      line-height: 60px;
      float: right;
    }
    &:hover {
      background: #2858E0;
    }
    &:last-child {
      border-bottom: none;
    }
    .subNav {
      display: none;
      padding-left: 26px;
      border-top: 1px solid rgba($color: #ffffff, $alpha: .2);
      font-size: 21px;

      li {
        padding-left: 0;
        padding-right: 26px;
      }
    }
  }
  .h5active {
    background: #2858E0;
    .subNav {
      display: flex;
    }
  }
}
.active {
  font-weight: 700 !important;
  position: relative;
  .subNav {
    font-weight: 400 !important;
  }
}
.header-nav-h5 {
  align-items: center;
  justify-content: space-between;
  background: #2858E0;
  width: 100%;
  height: 66px;
  display: none;
  .logo-wrapper {
    font-size: 18px;
    display: flex;
    align-items: center;
    a {
      display: inline-block;
      .imageLogo {
        height: 36px;
        width: 228px;
        img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      }
    }
  }
  i.el-icon-s-unfold {
    display: block !important;
    flex: 1;
    font-size: 42px;
    margin-right: 10px;
    text-align: right;
  }
}
@media screen and (max-width: 768px) {
  .app-header {
    display: none;
  }
  .header-nav-h5 {
    display: flex;
  }
    .user-dialog-main {
      padding: 20px;
      display: block;
    .user-dialog-left {
      width: 100%;
      text-align: center;
      img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        margin-bottom: 10px;
      }
    }
    .user-dialog-right {
      margin-top: 30px;
      ul {
        li {
          margin-bottom: 20px;
          .clipboardName,
          .clipboardPhone {
            color: #007afc;
            margin-left: 10px;
            cursor: pointer;
            font-size: 14px;
            float: right;
            &:hover {
              // text-decoration: underline;
            }
          }
        }
      }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-to
    /* .fade-leave-active below version 2.1.8 */
      {
      opacity: 0;
    }
  }
}
</style>
